import { useMemo } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import ImageType from '../types/ImageType'
import { BynderPicture, CTALink, Typography } from 'common/widgets'
import classNames from './styles.module.scss'


Slide.propTypes = {
  image: ImageType,
  tag: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  text: PropTypes.string,
  caption: PropTypes.string,
  cta_link: PropTypes.string.isRequired,
  priority: PropTypes.bool,
}

export default function Slide({
  image = {},
  tag,
  heading,
  text = undefined,
  caption = '',
  cta_link: ctaLink,
  priority = false,
}) {
  const newHeading = useMemo(() => {
    const newHeading = heading.split('\r\n')

    return newHeading.map((heading, index) => (
      <Typography
        key={index}
        variant="h2"
        tag="div"
        color="white"
        className={classNames.heading}
        style={{ transitionDelay: `${1 + 0.3 * index}s` }}
      >
        {heading}
      </Typography>
    ))
  }, [heading])

  return (
    <div className={classNames.slide}>
      <div className={classNames.slideImage}>
        <BynderPicture
          image={image}
          priority={priority}
          mobileImage={{
            maxWidth: 800,
            maxHeight: 800,
            sizes: '100vw',
          }}
          desktopImage={{
            maxWidth: 1920,
            maxHeight: 700,
            sizes: '100vw',
          }}
        />
      </div>
      <div className={classNames.slideInfo}>
        <div className={classNames.borderTop} />
        <div className={classNames.borderRight} />
        <div className={classNames.borderBottom} />
        <div className={classNames.borderLeft} />
        <div className={classNames.infoText}>
          <div className={classNames.inlineContainer}>
            <Typography variant="subhead" color="white" className={classNames.tag} preLine>{tag}</Typography>
          </div>
          <div className={cx(classNames.inlineContainer, classNames.headingContainer)}>
            {newHeading}
          </div>
          {text && (
            <div className={classNames.inlineContainer}>
              <Typography color="white" className={classNames.text}>{text}</Typography>
            </div>
          )}
        </div>
        <CTALink
          ctaURL={ctaLink}
          icon="chevron-right"
          cta={caption}
          className={classNames.cta}
        />
      </div>
    </div>
  )
}
